import axios from 'axios'

export const fetchPrivacyPolicy = () =>
  axios.get('/public/privacy-policy').then((response) => response.data)
